import VocHeaderMenuMobile from "../header-menu-new/src/header-menu-mobile"

/* istanbul ignore next */
VocHeaderMenuMobile.install = function (Vue) {
  Vue.component(VocHeaderMenuMobile.name, VocHeaderMenuMobile)
}

export default VocHeaderMenuMobile
